import React from "react";
import { useTranslation } from "react-i18next";
import "./lazy-error-screen.css";

export default function LazyErrorScreen({ onReload }) {
    const { t, i18n } = useTranslation();

    const isRTL = i18n.language?.includes("he");

    return (
        <div className={`lazy-error ${isRTL ? "lazy-error--rtl" : ""}`}>
            <div className="lazy-error__card">
                <div className="lazy-error__icon">
                    !
                </div>

                <span className="lazy-error__label">
                    {t("something_went_wrong", "Что-то пошло не так")}
                </span>

                <h1>
                    {t(
                        "page_loading_error",
                        "Не удалось загрузить страницу"
                    )}
                </h1>

                <p>
                    {t(
                        "page_loading_error_description",
                        "Произошла временная ошибка при загрузке раздела. Попробуйте перезагрузить страницу."
                    )}
                </p>

                <div className="lazy-error__notice">
                    <div className="lazy-error__noticeIcon">
                        ↻
                    </div>

                    <div>
                        <strong>
                            {t(
                                "your_data_is_safe",
                                "Ваши данные не потеряны"
                            )}
                        </strong>

                        <span>
                            {t(
                                "continue_after_reload",
                                "После перезагрузки вы сможете продолжить работу."
                            )}
                        </span>
                    </div>
                </div>

                <button
                    type="button"
                    className="lazy-error__button"
                    onClick={onReload}
                >
                    <span>↻</span>

                    {t(
                        "reload_page",
                        "Перезагрузить страницу"
                    )}
                </button>
            </div>
        </div>
    );
}
